import type { ReactNode } from 'react';
import { useApp } from '../../state';
import { Icon } from '../../ui';

/** Заголовок вложенного экрана: «назад» и название. В Telegram работает и системная кнопка «Назад». */
export function SubHead({ title, children }: { title: string; children?: ReactNode }) {
  const { close } = useApp();
  return (
    <div className="page-head" style={{ alignItems: 'center', marginTop: 0 }}>
      <button type="button" className="icon-btn" aria-label="Назад" onClick={close}>
        <Icon name="back" size={20} />
      </button>
      <h1 className="h1 grow">{title}</h1>
      {children}
    </div>
  );
}
